export default "__VITE_ASSET__DyfxFS3i__"